<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="floralVarietyForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :is-not-server-handled="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="floralVariety" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                floralVarietyForm: () => import('../forms/FloralVarietyForm'),
                floralVariety: () => import('../editViews/FloralVariety'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'floralVarieties',
                editPageName: 'floralVariety',
                apiMethod: 'FloralVarieties',
                claimName: 'FloralVarieties',
                formTitle: 'Floral Variety',
                excelTitle: 'Floral Varieties',
                hasEditPage: true,
            }
        },
    };
</script>
